import { AllocateSingleId } from "../../AllocateId";
import { GetMasterTableEntries } from "../../GetMasterTableEntries";
import { DeleteFromServer, FetchFromServer, SaveToServer } from "../../Post";


const MasterTableName = "GAAProjectSpaceTypeAreas";
const FetchRequestType = "GAAProjectSpaceTypeAreaFetchRequest";

export const SaveProjectSpaceTypeArea = async (ref, payload) => {
  payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, []);
};

export const GetProjectSpaceTypeAreaList = async () => {
  let payload = { Refs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  //  result = result.sort((a, b) => a.Name.localeCompare(b.Name));
  return result;
};

export const GetProjectSpaceTypeArea = async (Ref) => {
  let payload = { GAAProjectSpaceTypeAreaRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};

export const DeleteProjectSpaceTypeArea = async (payload) => {
  return await DeleteFromServer(payload, MasterTableName);
};

export const GetGAAProjectSpaceTypeAreaListBySpaceType = async (GAAProjectSpaceTypeRef) => {
  let payload = { GAAProjectSpaceTypeRefs: [GAAProjectSpaceTypeRef] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  return result;
};

